/**
 * Utilitaires pour gérer le cache du dashboard
 */

const CACHE_PREFIX = 'dashboard:'
const CACHE_TTL_MS = 5 * 60 * 1000 // 5 minutes par défaut

/**
 * Invalide le cache du dashboard pour un vendeur spécifique
 */
export function invalidateDashboardCache(vendeurId: number): void {
  try {
    const keysToRemove: string[] = []

    // Parcourir localStorage pour trouver les clés du dashboard
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(CACHE_PREFIX) && key.includes(`:${vendeurId}:`)) {
        keysToRemove.push(key)
      }
    }

    // Supprimer les clés trouvées
    keysToRemove.forEach(key => {
      localStorage.removeItem(key)
    })

  } catch (error) {
    // Ignore les erreurs d'invalidation du cache
  }
}

/**
 * Fonction helper pour mettre en cache une valeur
 */
export function safeSetCache(key: string, value: unknown, ttlMs: number = CACHE_TTL_MS): void {
  try {
    const payload = { expires: Date.now() + Math.max(1000, ttlMs), value }
    localStorage.setItem(key, JSON.stringify(payload))
  } catch {
    // ignore stockage erreurs (quota, privacy, etc.)
    void 0
  }
}

/**
 * Fonction helper pour récupérer du cache
 */
export function safeGetCache<T = unknown>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    const expires = parsed.expires as number | undefined
    if (!expires || Date.now() > expires) {
      // expiré
      try { localStorage.removeItem(key) } catch { /* ignore storage remove errors */ void 0 }
      return null
    }
    return parsed.value as T
  } catch {
    return null
  }
}
